import StyleConfTemplate from './StyleConfTemplate';
import WRadio from "../../../../../lib/builtin/components/Radio/index";
import ColorPicker from "../../../../../lib/builtin/components/ColorPicker/index";
import StylePanelMixin from '../utils/StylePanelMixin';
const __script_base__ = {
  name: 'SPHover',
  extends: StylePanelMixin,
  components: {
    StyleConfTemplate,
    ColorPicker,
    WRadio
  },
  data() {
    const h = this.$createElement;
    return {
      showPreview: false,
      cursorOptions: [{
        label: h("span", {
          "attrs": {
            "title": "pointer"
          },
          "class": "ucd-stylePanel-enumBox",
          "style": "cursor: pointer"
        }, [" \u70B9\u51FB "]),
        value: 'pointer'
      }, {
        label: h("span", {
          "attrs": {
            "title": "auto"
          },
          "class": "ucd-stylePanel-enumBox",
          "style": "cursor: grab"
        }, [" \u6293\u624B "]),
        value: 'grab'
      }, {
        label: h("span", {
          "attrs": {
            "title": "auto"
          },
          "class": "ucd-stylePanel-enumBox",
          "style": "cursor: not-allowed"
        }, [" \u7981\u6B62 "]),
        value: 'not-allowed'
      }, {
        label: h("span", {
          "attrs": {
            "title": "auto"
          },
          "class": "ucd-stylePanel-enumBox",
          "style": "cursor: zoom-in"
        }, [" \u653E\u5927 "]),
        value: 'zoom-in'
      }],
      boxShadowOptions: [{
        label: h("div", ["\u7ECF\u5178"]),
        value: '#CBCBCBFF 3px 5px 7px 2px'
      }, {
        label: h("div", ["\u6241\u5E73"]),
        value: '#E7E5E5FF 4px 4px 3px -2px'
      }, {
        label: h("div", ["\u7ACB\u4F53"]),
        value: '#979797FF 1px 2px 4px 2px'
      }],
      borderStyleOption: [{
        value: 'solid',
        label: '实线'
      }, {
        value: 'dotted',
        label: '点线'
      }, {
        value: 'dashed',
        label: '虚线'
      }],
      transformOption: [{
        value: 'scale(1.02)',
        label: '经典'
      }, {
        value: 'scale(1.04)',
        label: '强调'
      }],
      textColorOptions: [{
        label: h("div", {
          "style": "color: #161616"
        }, ["\u9ED1"]),
        value: '#161616'
      }, {
        label: h("div", {
          "style": "color: #5C5C5C"
        }, ["\u7070"]),
        value: '#5C5C5C'
      }, {
        label: h("div", {
          "style": "color: #00A870"
        }, ["\u7EFF"]),
        value: '#00A870'
      }, {
        label: h("div", {
          "style": "color: #ED7B2F"
        }, ["\u9EC4"]),
        value: '#ED7B2F'
      }, {
        label: h("div", {
          "style": "color: #E34D59"
        }, ["\u7EA2"]),
        value: '#E34D59'
      }],
      helpText: `开启预览后可以即时查看悬浮样式
开启后:样式面板将变成悬浮作用域`
    };
  },
  methods: {
    deleteHoverStyle(key) {
      this.$delete(this.hoverStyle, key);
    }
  },
  watch: {
    showPreview: {
      handler() {
        this.$emit('hoverpreviewswitch', this.showPreview);
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("StyleConfTemplate", {
    attrs: {
      name: "开启预览",
      inline: true,
      changed: false,
      placement: "top"
    }
  }, [_c("div", {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      slot: "tooltip"
    },
    domProps: {
      textContent: _vm._s(_vm.helpText)
    },
    slot: "tooltip"
  }), _vm._v(" "), _c("a-switch", {
    model: {
      value: _vm.showPreview,
      callback: function ($$v) {
        _vm.showPreview = $$v;
      },
      expression: "showPreview"
    }
  })], 1), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "背景颜色",
      inline: true,
      changed: _vm.changedFromDefault("backgroundColor", "", _vm.hoverStyle)
    },
    on: {
      reset: function ($event) {
        return _vm.deleteHoverStyle("backgroundColor");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("color-picker", {
    attrs: {
      placement: "topRight",
      value: _vm.hoverStyle.backgroundColor
    },
    on: {
      change: function (val) {
        return _vm.changeHover("backgroundColor", val);
      }
    }
  })], 1)]), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "字体颜色",
      inline: true,
      changed: _vm.changedFromDefault("color", "#000", _vm.hoverStyle)
    },
    on: {
      reset: function ($event) {
        return _vm.deleteHoverStyle("color");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("WRadio", {
    attrs: {
      options: _vm.textColorOptions,
      value: _vm.hoverStyle.color
    },
    on: {
      change: function (val) {
        return _vm.changeAndDeleteHover("color", val);
      }
    }
  }), _vm._v(" "), _c("color-picker", {
    attrs: {
      placement: "topRight",
      value: _vm.hoverStyle.color || "#000"
    },
    on: {
      change: function (val) {
        return _vm.changeHover("color", val);
      }
    }
  })], 1)]), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "指针样式",
      inline: true,
      changed: _vm.changedFromDefault("cursor", "", _vm.hoverStyle)
    },
    on: {
      reset: function ($event) {
        return _vm.deleteHoverStyle("cursor");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("WRadio", {
    attrs: {
      "with-solid-fill": "",
      value: _vm.hoverStyle.cursor,
      options: _vm.cursorOptions
    },
    on: {
      change: function (val) {
        return _vm.changeAndDeleteHover("cursor", val);
      }
    }
  })], 1)]), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "阴影",
      inline: true,
      changed: _vm.changedFromDefault("boxShadow", "", _vm.hoverStyle)
    },
    on: {
      reset: function ($event) {
        return _vm.deleteHoverStyle("boxShadow");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("WRadio", {
    attrs: {
      "with-solid-fill": "",
      value: _vm.hoverStyle.boxShadow,
      options: _vm.boxShadowOptions
    },
    on: {
      change: function (val) {
        return _vm.changeAndDeleteHover("boxShadow", val);
      }
    }
  })], 1)]), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "边框",
      inline: true,
      changed: _vm.changedFromDefault("borderStyle", "", _vm.hoverStyle) || _vm.changedFromDefault("borderColor", "", _vm.hoverStyle)
    },
    on: {
      reset: function () {
        _vm.deleteHoverStyle("borderColor");
        _vm.deleteHoverStyle("borderStyle");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("WRadio", {
    attrs: {
      "with-solid-fill": "",
      value: _vm.hoverStyle.borderStyle,
      options: _vm.borderStyleOption
    },
    on: {
      change: function (val) {
        return _vm.changeAndDeleteHover("borderStyle", val);
      }
    }
  }), _vm._v(" "), _c("color-picker", {
    attrs: {
      placement: "topRight",
      value: _vm.hoverStyle.borderColor
    },
    on: {
      change: function (val) {
        return _vm.changeHover("borderColor", val);
      }
    }
  })], 1)]), _vm._v(" "), _c("StyleConfTemplate", {
    attrs: {
      name: "缩放",
      inline: true,
      changed: _vm.changedFromDefault("transform", "", _vm.hoverStyle)
    },
    on: {
      reset: function () {
        _vm.deleteHoverStyle("transform");
        _vm.deleteHoverStyle("transition");
      }
    }
  }, [_c("div", {
    staticClass: "uc-stylePanel-sliderInput-wrapper"
  }, [_c("WRadio", {
    attrs: {
      "with-solid-fill": "",
      value: _vm.hoverStyle.transform,
      options: _vm.transformOption
    },
    on: {
      change: function (val) {
        return _vm.changeAndDeleteHover("transform", val);
      }
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/hover.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);